import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const flavourModURL = "api/v1/products-app/flavour";
//obtaining the paginated data
export const getFlavour = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`${flavourModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
  // axiosInstance.get(`${flavourModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);
};
//obtaining all fiscal sessions
export const getAllFlavour = () => axiosInstance.get(`${flavourModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageFlavour = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${flavourModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createFlavour = (body) => axiosInstance.post(`${flavourModURL}/create`, body);
//updating function
export const updateFlavour = (id, body) => axiosInstance.patch(`${flavourModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${flavourModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`);

// checking the redundant data
export const checkRedundantDataFlavourName = (e, cancelToken) =>
  axiosInstance.get(`${flavourModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
